 

<template>
    <div class="chart-block" style="min-height:298px;padding:20px" id="s4block">
        <el-carousel trigger="click" height="290px">
            <el-carousel-item key="first">
   <div class="s4-block">
       <div class="quantity"> 新四化总体 <svg-icon name="sales" size="50"></svg-icon>
              <el-divider><i class="el-icon-s-data green"></i></el-divider>
             {{info.total}} </div>
   </div>

            </el-carousel-item>
            <el-carousel-item key="second">
                <h4 class="small">电动化</h4>
                <div class="s4-block">
                    <div class="yearly-total">{{info.dian}}  </div>
                    <div class="yearly-sale-m"> </div>
                    <!-- <el-divider><i class="el-icon-s-data"></i></el-divider> -->
                    <el-divider><i class="el-icon-s-data green"></i></el-divider>
                    <div style="display:flex">
                        <div style="flex-grow:1;">
                            <div class="sale-pre green">{{info.dian_mom * 100}}%</div>
                            同比
                        </div>
                        <div style="flex-grow:1;">
                            <div class="sale-pre red">{{info.dian_yoy * 100}}%</div>
                            环比</div>
                    </div>
                </div>
            </el-carousel-item>
          <el-carousel-item key="third">
            <h4 class="small">智能化</h4>
             <div class="s4-block">
                    <div class="yearly-total">{{info.zhi}}   </div>
                    <div class="yearly-sale-m"> </div>
                    <!-- <el-divider><i class="el-icon-s-data"></i></el-divider> -->
                    <el-divider><i class="el-icon-s-data green"></i></el-divider>
                    <div style="display:flex">
                        <div style="flex-grow:1;">
                            <div class="sale-pre green">{{info.zhi_mom * 100}}%</div>
                            同比
                        </div>
                        <div style="flex-grow:1;">
                            <div class="sale-pre red">{{info.zhi_yoy * 100}}%</div>
                            环比</div>
                    </div>
                </div>
          </el-carousel-item>
            <el-carousel-item key="fourth">
            <h4 class="small">网联化</h4>
            <div class="s4-block">
                    <div class="yearly-total">{{info.wang}}  </div>
                    <div class="yearly-sale-m"> </div>
                    <!-- <el-divider><i class="el-icon-s-data"></i></el-divider> -->
                    <el-divider><i class="el-icon-s-data green"></i></el-divider>
                    <div style="display:flex">
                        <div style="flex-grow:1;">
                            <div class="sale-pre green">{{info.wang_mom * 100}}%</div>
                            同比
                        </div>
                        <div style="flex-grow:1;">
                            <div class="sale-pre red">{{info.wang_yoy * 100}}%</div>
                            环比</div>
                    </div>
                </div>
          </el-carousel-item>  
        </el-carousel>
    </div>
</template>
<script>
  import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
import {formatDate,strToFormatDate,strToYeayAndMonth} from "@/plugins/DateTimeFormater.js";
    export default {
        props: {
           chartName:{type:String,default:'新四化销量'}
        },
        data() {
            return {
                url:"#",
                chartOption: {},
                chartId:"new42",
                updated:"",
                info:{}
            }
        },
        mounted() {
            this.getChartList({handle:this.updateChart});
            
        },
        methods: {
            ...mapActions("home", ["getChartList"]),
               updateChart(res){
                  var row = this.getChartByName(this.chartId);
                   this.info = eval('['+row.jsonData+']')[0];
                   this.url = info.url;
                  //this.info =  eval(row.jsonData);
           this.updated = `${strToYeayAndMonth(row.lastUpdated)}更新`;
            }
        },
   
          computed: {
    ...mapGetters("home", {chartList: "chartList",getChartByName: "getChartByName"}),
      }
    }
</script>
<style scoped>
    .s4-block .quantity{
        line-height: 120px;
        font-size:3.8em;
    }
    .x-line {
        height: 1px;
        border-bottom: 1px dashed #ccc;
        margin: 10px;
    }
</style>
